import { h } from 'preact';
import { ContainerSize } from '@cube/blocks';
import cx from 'classnames';
import style from './style';

const Footnotes = ({ notes, ...props }) => {
	if (!notes || notes.length === 0) {
		return;
	}
	let footnotes = notes.reduce((acc, note, index) => {
		let footnote = <div class={style.footnote}><sup>{index + 1}</sup> {note.text}</div>;
		if (acc.length === 0) {
			acc.push([footnote]);
			return acc;
		}

		if (note.break) {
			acc.push([footnote]);
			return acc;
		}

		let last = acc.pop();
		last.push(footnote);
		acc.push(last);
		return acc;

	}, []);

	return (
		<ContainerSize height={false} class={cx(style.footnoteContainer, props.class)}>
			{ footnotes.map((footnoteSet) => <FootnoteContainer noteSet={footnoteSet} />) }
		</ContainerSize>
	);
};

export default Footnotes;

export const FootnoteContainer = ({ noteSet, width }) => (
	<div class={cx(style.footnoteChildContainer, width > 600 && style.split)}>
		{ noteSet }
	</div>
);

export const FootnoteReference = ({ id, footnotes }) => {
	if (!footnotes) return;
	let note,
		index = false;

	if (footnotes) {
		for (let i = 0; i < footnotes.length;i++) {
			note = footnotes[i];
			if (note.name === id) {
				index = i + 1;
				break;
			}
		}
	}

	return (
		index && <sup>{index}</sup>
	);
};
